<template>

<div class="trend">

	<div class="trend-item" v-for="(v, index) in value" :key="index" :style="styleItem(v, index)">
    
        {{ config.labels[index] }}

    </div>

</div>

</template>

<script>

export default {

	props: ['value', 'config'],

	methods: {

		styleItem: function(value, index) {

			var style = {
				width: false,
				backgroundColor: false
			}

			var percent = (100 / this.config.max) * value;

			if (percent > 100) percent = 100

			style.width = percent.toString() + '%'

			if(this.config.themes) {

				style.backgroundColor = this.config.themes[index]

			} else {

				this.$_.each(this.config.colors, function(hex, threshold) {

					if (threshold <= value) style.backgroundColor = hex

				})

			}
			return style

		}

	}

}

</script>

<style scoped>

.trend {
	display: flex;
	width: 100%;
    height: 84px;
    border-radius: 4px 4px 0px 0px;
	justify-content: center;
	align-items: flex-end;
    overflow: hidden;
}

.trend-item {
    height: 100%;
    display: flex;
	justify-content: center;
    align-items: center;
    color: rgba(255, 255, 255 , 1);
    font-size: 16px;
    min-width: 24px;
}

</style>